import React, {  useState } from "react";
import ReactDOM from "react-dom";
import data from "./PeriodicTableJSON.json";
import "./PeriodicTable.css";
import axios from "axios";


const colorMap = {
  "noble gas": "#FFBC42",
  "alkaline earth metal": "#EC674E",
  "diatomic nonmetal": "#D81159",
  "alkali metal": "#8F2D56",
  "transition metal": "#58586B",
  "post-transition metal": "#218380",
  lanthanide: "#4AABAF",
  metalloid: "#73D2DE",
};

const PeriodicTable = () => {

  const [selectedElement, setSelectedElement] = useState([])
  const [elements,setElemets] = useState([])

  function handleClick(x) {
    // console.log(x)
    if (!selectedElement.includes(x) ) {
      setSelectedElement([...selectedElement, x])
      setElemets([...elements,[x,0]])
    } 
    
    // else {
    //   let index = selectedElement.indexOf(x);
    //   if (index > -1) {
    //     selectedElement.splice(index, 1);
    //     elements.splice(index,1)
    //   }
    //   setSelectedElement(selectedElement)
    //   setElemets(elements)
    // }
  }

  function handleChangeMoleFraction(x, moleFraction){
    // console.log(x.name,moleFraction, "----------->")
    let elementsPresent = []
    for(var i = 0; i< elements.length; i++){
      elementsPresent.push(elements[i][0].name)
    }
    // console.log(elementsPresent, "=======+>")
    // console.log(elements.includes(x.name))
    if(!elementsPresent.includes(x.name)){
      elements = [...elements,[x.name,moleFraction]]
    }else{
      let index = elementsPresent.indexOf(x.name)
      elements[index][1] = moleFraction
    }
    selectedElement(elements)
  }

  function pressedPredict(e){
    // console.log(elements)
    let sum = 0
    for(var i = 0; i < elements.length; i++){
      let temp = elements[i][1]
      sum += +temp
    }
    // console.log(sum)

    // ReactDOM.render(, document.getElementById('pred-res'));
    if(sum === 1){
      setFirstClick(true)
    callApi(e)
    }
    else{
      ReactDOM.render(<p>Invalid Composition!</p>, document.getElementById('inval-res'))
    }

  }

  const [rf,setRf] = useState('')
  const [dt,setDt] = useState('')
  const [knn,setKnn] = useState('')
  const [lr,setLr] = useState('')
  const [nb,setNb] = useState('')
  const [svml,setSvml] = useState('')
  const [vec,setVec] = useState('')
  const [dx,setDx] = useState('')
  const [delta,setDelta] = useState('')
  const [h_mix,setHmix] = useState('')
  const [s_mix,setSmix] = useState('')
  const [firstClick,setFirstClick] = useState(false)

  async function callApi(e) {
    e.preventDefault();
    axios
      .post("https://structure-predictor.onrender.com/api/predictNew/", {
        elements : elements
      })
      .then((resp) => {
        // console.log(resp);
         setRf (resp.data.prediction_rf)
         setDt (resp.data.prediction_dt)
         setNb (resp.data.prediction_nb)
         setLr (resp.data.prediction_lr)
         setKnn (resp.data.prediction_knn)
         setSvml (resp.data.prediction_svml)
         setVec (resp.data.VEC)
         setDx (resp.data.dx)
         setDelta (resp.data.delta)
         setHmix (resp.data.h_mix)
         setSmix (resp.data.s_mix)

        // console.log(resp.data)
        // navigate('/sentences')
      })
      .catch((error) => {
        console.error(error.response);
      });
  }

  return (

    <>
    <div className="instructions">
      <h4>Instructions:</h4>
      <ul>
        <li>Select the alloying elements of your choice by clicking on its symbol on the periodic table.(Note: Only elements highlighted by green background can be selected.)</li>
        <li>The selected elements will be displayed below. Fill in the concentration (Mole fraction 0&lt;=C<sub>i</sub>&lt;=1) of each element.</li>
        <li>Make sure that the composition is valid i.e. Sum of all the mole fractions is equal to 1.</li>
        <li>Click on the Predict button and wait for the results.</li>
      </ul>
    </div>
    <div className="section">
    <div className="periodic-table">
        
        {data.elements.map((element) => (
          <div
            className={"" + (element.disabled ? 'element disabled' : 'element active')}
            key={element.name}
            style={{
              gridRow: element.ypos,
              gridColumn: element.xpos,
              borderColor: colorMap[element.category],
            }}
            onClick={(e) => { handleClick(element) }}
          >
            <strong>{element.symbol}</strong>
            <small className="number">{element.number}</small>
            <small className="name">{element.name}</small>
          </div>
        ))}
      </div>
      <div className="btn-container" style={{"zIndex" : "1", "position" : "relative", "marginTop" : "52%"}}>
        <button className="btn btn-primary" style={{"margin" : "1%"}}  onClick={(e) => { pressedPredict(e) }}>Predict</button>
        <button className = "btn btn-danger"  onClick={() => {window.location.reload(false)}}>Clear</button>
      </div>
      <div className="container d-flex p-3" style={{ "justifyContent" : "center", "fontSize" : "20px" }}>
      {selectedElement.map((x,i) => (
          <div>{x.name} <br/><input placeholder="Mole Fraction" step=".01" type="number" style = {{width : "60%", fontSize : "12px"}}onChange={ (e) => {handleChangeMoleFraction(x,e.target.value)}} required/></div>
          
        ))}
      </div>
      <div id="pred-res">
        {firstClick? <><h3>Calculated Parameters</h3><table className="table-content">
            <thead>
              <tr>
                <th className="table-head">Valence electron concentration (VEC)</th>
                <th className="table-head">Pauling negativity difference (dx)</th>
                <th className="table-head">Atomic size difference (delta)</th>
                <th className="table-head">Mixing enthalpy (H<sub>mix)</sub></th>
                <th className="table-head">Mixing entropy (S<sub>mix)</sub></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="table-body">{vec}</td>
                <td className="table-body">{dx}</td>
                <td className="table-body">{delta}</td>
                <td className="table-body">{h_mix}</td>
                <td className="table-body">{s_mix}</td>
              </tr>
            </tbody>
          </table>
          <h3 style={{ "marginTop" : "5%" }}>Predictions</h3><table className="table-content1">
            <thead>
              <tr>
                <th className="table-head">Algorithm</th>
                <th className="table-head">Prediction</th>
                <th className="table-head">Accuracy(%)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="table-body">Random Forest</td>
                <td className="table-body">{rf}</td>
                <td className="table-body">91.66</td>
              </tr>
              <tr>
                <td className="table-body">Decision Tree</td>
                <td className="table-body">{dt}</td>
                <td className="table-body">83.33</td>
              </tr>
              <tr>
                <td className="table-body">K-nearest neighbors</td>
                <td className="table-body">{knn}</td>
                <td className="table-body">88.88</td>
              </tr>
              <tr>
                <td className="table-body">Logistic Regression</td>
                <td className="table-body">{lr}</td>
                <td className="table-body">77.77</td>
              </tr>
              <tr>
                <td className="table-body">Naive Based</td>
                <td className="table-body">{nb}</td>
                <td className="table-body">86.11</td>
              </tr>
              <tr>
                <td className="table-body">Support vector machine</td>
                <td className="table-body">{svml}</td>
                <td className="table-body">88.88</td>
              </tr>
            </tbody>
            </table>
            </> : <></> }
      
      </div>
      <div id="inval-res"></div>
    </div>
      
      
    </>
  );
};

export default PeriodicTable;

// Min 3 elements max 5 elements. Varying percentage dropdown. 
